export const LANGUAGE_SESSION_STORAGE_KEY = 'LANGUAGE';
export const LANGUAGE_ENABLED_SESSION_STORAGE_KEY = 'LANGUAGE_ENABLED';
